import {
  SETTING_ACCOUNT_RELOAD_DATA,
  SETTING_ACCOUNT_SHOW_ALL,
  SETTING_ACCOUNT_SHOW_PROFILE,
  SETTING_ACCOUNT_SHOW_BUSINESS,
  SETTING_ACCOUNT_SHOW_PASSWORD,
  SETTING_ACCOUNT_GET_ALL_DATA,
  SETTING_ACCOUNT_SET_PROFILE,
  SETTING_ACCOUNT_SET_BUSINESS,
  SETTING_ACCOUNT_SET_BUSINESS_LOCATION,
  SETTING_ACCOUNT_SET_KYB,
  SETTING_ACCOUNT_SET_KYB_INCOMPLETE,
  SETTING_ACCOUNT_UPDATE_PROFILE,
  SETTING_ACCOUNT_UPDATE_BUSINESS,
  SETTING_ACCOUNT_UPDATE_PASSWORD,
  SETTING_ACCOUNT_SHOW_OTP_MODAL,
  SETTING_ACCOUNT_REQUEST_OTP,
  SETTING_ACCOUNT_REQUEST_UPDATE_OTP,
  SETTING_ACCOUNT_VERIFY_OTP,
  SETTING_ACCOUNT_VERIFY_UPDATE_OTP,
  SETTING_ACCOUNT_SET_OTP_ERROR_MSG,
  SETTING_ACCOUNT_SET_OTP_REQUEST_ID,
  SETTING_ACCOUNT_SET_STATUS_CODE,
  SETTING_ACCOUNT_UPLOAD_NPWP_FILE,
  SETTING_ACCOUNT_NPWP_FORM_DATA,
  SETTING_ACCOUNT_SHOW_NPWP,
} from './constants';

export function actReloadData() {
  return { type: SETTING_ACCOUNT_RELOAD_DATA, payload: 'RELOAD_DATA' };
}

export function actShowDetailPage() {
  return { type: SETTING_ACCOUNT_SHOW_ALL, payload: 'SHOW_DETAIL' };
}

export function actShowProfilePage() {
  return { type: SETTING_ACCOUNT_SHOW_PROFILE, payload: 'UPDATE_PROFILE' };
}

export function actShowBusinessPage() {
  return {
    type: SETTING_ACCOUNT_SHOW_BUSINESS,
    payload: 'UPDATE_BUSINESS_INFO',
  };
}

export function actShowPasswordPage() {
  return { type: SETTING_ACCOUNT_SHOW_PASSWORD, payload: 'UPDATE_PASSWORD' };
}

export function actGetAccountAllData(isOwner, businessId) {
  return {
    type: SETTING_ACCOUNT_GET_ALL_DATA,
    payload: { isOwner, businessId },
  };
}

export function actSetAccountProfile(data) {
  return { type: SETTING_ACCOUNT_SET_PROFILE, payload: { data } };
}

export function actSetAccountBusiness(data) {
  return { type: SETTING_ACCOUNT_SET_BUSINESS, payload: { data } };
}

export function actSetAccountBusinessLocation(data) {
  return { type: SETTING_ACCOUNT_SET_BUSINESS_LOCATION, payload: { data } };
}

export function actSetAccountKyb(data) {
  return { type: SETTING_ACCOUNT_SET_KYB, payload: { data } };
}

export function actSetAccountKybIncomplete(data) {
  return { type: SETTING_ACCOUNT_SET_KYB_INCOMPLETE, payload: { data } };
}

export function actUpdateAccountProfile(data) {
  return { type: SETTING_ACCOUNT_UPDATE_PROFILE, payload: { data } };
}

export function actUpdateAccountBusinessInfo(data) {
  return { type: SETTING_ACCOUNT_UPDATE_BUSINESS, payload: { data } };
}

export function actUpdateAccountPassword(data) {
  return { type: SETTING_ACCOUNT_UPDATE_PASSWORD, payload: { data } };
}

export function actShowOtpModal(showModal) {
  return { type: SETTING_ACCOUNT_SHOW_OTP_MODAL, payload: { showModal } };
}

export function actRequestOtp(phone, resend) {
  return { type: SETTING_ACCOUNT_REQUEST_OTP, payload: { phone, resend } };
}

export function actRequestUpdateOtp(phone, resend) {
  return {
    type: SETTING_ACCOUNT_REQUEST_UPDATE_OTP,
    payload: { phone, resend },
  };
}

export function actVerifyOtp(data) {
  return { type: SETTING_ACCOUNT_VERIFY_OTP, payload: { data } };
}

export function actVerifyUpdateOtp(data) {
  return { type: SETTING_ACCOUNT_VERIFY_UPDATE_OTP, payload: { data } };
}

export function actSetOtpErrorMessage(otpError) {
  return { type: SETTING_ACCOUNT_SET_OTP_ERROR_MSG, payload: { otpError } };
}

export function actSetOtpRequestId(requestId) {
  return { type: SETTING_ACCOUNT_SET_OTP_REQUEST_ID, payload: { requestId } };
}

export function actSetStatusCode(statusCode) {
  return { type: SETTING_ACCOUNT_SET_STATUS_CODE, payload: { statusCode } };
}

export function actUploadNpwpFile(data) {
  return { type: SETTING_ACCOUNT_UPLOAD_NPWP_FILE, payload: { data } };
}

export function submitNpwpForm(data) {
  return { type: SETTING_ACCOUNT_NPWP_FORM_DATA, payload: data };
}

export function actShowNpwpPage() {
  return { type: SETTING_ACCOUNT_SHOW_NPWP, payload: 'UPDATE_NPWP_INFO' };
}
